import EmailConfirmation from '../components/EmailConfirmation'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  email: state.emailConfirmation.email,
  progress: state.signup.progress,
  step: state.signup.step,
})

export default connect(
  mapStateToProps,
)(EmailConfirmation)



// WEBPACK FOOTER //
// ./src/routes/emailConfirmation/containers/EmailConfirmationContainer.js